import { render } from "./MyCourses.vue?vue&type=template&id=21ed4402&scoped=true"
import script from "./MyCourses.vue?vue&type=script&lang=js"
export * from "./MyCourses.vue?vue&type=script&lang=js"

import "./MyCourses.vue?vue&type=style&index=0&id=21ed4402&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-21ed4402"]])

export default __exports__